import { MarketingNav } from "@/components/marketing/MarketingNav";
import { Footer } from "@/components/landing/Footer";
import { SeoHead } from "@/components/SeoHead";

// Shared shell for all footer/marketing pages: nav + SEO + Footer.
export function PageShell({ seo, children, testid }) {
  return (
    <div data-testid={testid} className="relative min-h-screen w-full bg-background text-foreground">
      <SeoHead {...seo} />
      <MarketingNav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

// Standard left-aligned page hero.
export function PageHero({ eyebrow, title, subtitle, accent = "#0FAE96", testid }) {
  return (
    <section className="relative overflow-hidden pt-36 pb-14 sm:pt-40">
      <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.16]"
        style={{ background: `radial-gradient(55rem 26rem at 25% -10%, ${accent}, transparent)` }} />
      <div className="relative mx-auto w-full max-w-5xl px-6">
        {eyebrow && (
          <p className="font-mono text-[11px] uppercase tracking-[0.22em]" style={{ color: accent }}>{eyebrow}</p>
        )}
        <h1 data-testid={testid} className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
